import { headerLinkListStyles as styles } from "@insite/content-library/Widgets/Header/HeaderLinkList";
import { css } from "styled-components";

styles.headerLinkListWrapper = {
    ...styles.headerLinkListWrapper,
    css: css`
        ${styles.headerLinkListWrapper?.css}
        padding: 0;
        margin: 0;
    `,
};

styles.link = {
    ...styles.link,
    typographyProps: {
        ...styles.link?.typographyProps,
        size: 16,
        weight: 400,
    },
};
